const sizes = ["40em", "52em", "64em", "80em"];

export const breakpoints = {
    sm: `(max-width:${sizes[0]})`,
    md: `(max-width:${sizes[1]})`,
    lg: `(max-width:${sizes[2]})`,
    xl: `(max-width:${sizes[3]})`,
};
